import { lazy } from "react";

export const tenantRegistry = {
  default: {
    gisterSteps: [
      lazy(() => import("./sharedComponents/gister/GenericGisterPage")),
    ],
  },
  mayo: {
    login: lazy(() => import("./mayo/login/LoginPage")),
    panel: lazy(() => import("./mayo/panel/PanelPage")),
    gisterSteps: [
      lazy(() => import("./mayo/gister/MayoGister"))
    ]
  },
  gi: {
    login: lazy(() => import("./gi/login/GILoginPage")),
    panel: lazy(() => import("./gi/panel/GIPanelPage")),
    gisterSteps: [
      lazy(() => import("./gi/gister/GIGisterPage")),
    ]
  },
};
